import { render, staticRenderFns } from "./CommentsProfile.vue?vue&type=template&id=43c5d3d4&scoped=true&"
import script from "./CommentsProfile.vue?vue&type=script&lang=js&"
export * from "./CommentsProfile.vue?vue&type=script&lang=js&"
import style0 from "./CommentsProfile.vue?vue&type=style&index=0&id=43c5d3d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c5d3d4",
  null
  
)

export default component.exports